<template>
    <div class='content'>
        <div class="con-1">
            <div class="con-2">{{ $t('content184') }}</div>
            <div style="display: flex;justify-content: center;">
                <div class="con-3">
                    {{ $t('content185') }}</div>
            </div>
            <img src="@/assets/fangda5.png" class="con-3-img" alt="">
        </div>

        <div class="con-4">

            <div>
                <div class="con-6">{{ $t('content186') }}</div>
                <div class="con-7">
                    {{ $t('content187') }}</div>
                <div class="con-7">
                    {{ $t('content188') }}</div>
                <div class="con-7">
                    {{ $t('content189') }}</div>

            </div>
            <div>
                <img :src="$i18n.locale == 'zh' ? require('@/assets/gushi_img@2x.png'):require('@/assets/en_gushi_img@2x.png')" class="con-8-img" alt="">
            </div>
        </div>
        <div class="con-9">
            {{ $t('content190') }}</div>
        <div class="con-11">
            <div>
                <img :src="$i18n.locale == 'zh' ? require('@/assets/zidonghua_img@2x.png'): require('@/assets/en_zidonghua_img@2x.png')" class="con-11-img" alt="">
            </div>
            <div class="con-12">
                {{ $t('content191') }}
            </div>
        </div>
        <div class="con-13">
            <div>
                <img :src="$i18n.locale == 'zh' ? require('@/assets/quanchangjing_img@2x.png'):require('@/assets/en_quanchangjing_img@2x.png')" class="con-13-img" alt="">
            </div>
            <div class="con-12">
                {{ $t('content192') }}
            </div>
        </div>
        <div class="con-16">
            <div>
                <img :src="$i18n.locale == 'zh' ? require('@/assets/api_img@2x.png'):require('@/assets/en_api_img@2x.png')" class="con-16-img" alt="">
            </div>
            <div class="con-12">
                {{ $t('content193') }}
            </div>
        </div>
        <div class="con-18">
            <div>
                <img :src="$i18n.locale == 'zh' ? require('@/assets/gaoxiao_img@2x.png'):require('@/assets/en_gaoxiao_img@2x.png')" class="con-16-img" alt="">
            </div>
            <div class="con-12">
                {{ $t('content194') }}
            </div>
        </div>
    </div>
</template>

<script>
//import

export default {
    name: 'regArding',
    components: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    watch: {},
    methods: {

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
}
</script>
<style scoped>
.content{
  padding-top: 290px;
}
.con-1 {
    position: relative;
}

.con-2 {
    font-size: 82px;
    color: #333;
    text-align: center;
    margin-bottom: 50px;
}

.con-3 {
    font-size: 72px;
    color: #666666;
    width: 1700px;
    margin-bottom: 50px;
}

.con-3-img {
    width: 100%;
    height: 100%;
}

.con-4 {
    padding: 47px;
}


.btn-box {
    margin-top: 58px;
    text-align: center;
    display: flex;
    justify-content: center;
    margin-bottom: 49px;
    position: absolute;
    top: 435px;
    left: 360px;
}

.con-6 {
    font-size: 82px;
    color: #333333;
    margin-bottom: 50px;
    text-align: center;
    font-weight: 600;
}

.con-7 {
    font-size: 72px;
    color: #666666;
    margin-bottom: 50px;
    line-height: 110px;
}



.con-8-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.con-9 {
    font-size: 82px;
    color: #333;
    text-align: center;
    margin-top: -100px;
    margin-bottom: 65px;
    font-weight: 600;
}



.btn-blue {
    width: 132px;
    height: 44px;
    font-size: 18px;
    background-color: #4873FF;
    color: #fff;
    border-radius: 5px;
    line-height: 44px;
    text-align: center;
    margin-right: 12px;
    cursor: pointer;

}

.con-11 {
    text-align: center;
}

.con-11-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.con-12 {
    font-size: 82px;
    color: #333;
    margin-bottom: 115px;
    margin-top: 115px;
}

.con-13 {
    text-align: center;
    margin-bottom: 67px;
}

.con-13-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}



.con-16 {
    text-align: center;
}

.con-18 {
    text-align: center;
}

.con-16-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.con-17 {
    font-size: 24px;
    color: #333;
    margin-top: 30px;
}

.btn-we {
    width: 132px;
    height: 44px;
    font-size: 18px;
    background-color: #fff;
    color: #4873FF;
    border-radius: 5px;
    line-height: 44px;
    text-align: center;
    cursor: pointer;

    border: 1px solid #4873FF;
    margin-left: 12px;

}
</style>